import { render, staticRenderFns } from "./TeacherSpeechRecognition.vue?vue&type=template&id=e4fb3fc2&scoped=true"
import script from "./TeacherSpeechRecognition.vue?vue&type=script&lang=ts"
export * from "./TeacherSpeechRecognition.vue?vue&type=script&lang=ts"
import style0 from "./TeacherSpeechRecognition.vue?vue&type=style&index=0&id=e4fb3fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fb3fc2",
  null
  
)

export default component.exports